//= ============================================================
//
//   ####  #####  #####    ##   ##  ##   ####  #####   ####
//  ##     ##     ##  ##   ##   ##  ##  ##     ##     ##
//   ###   #####  #####    ##   ##  ##  ##     #####   ###
//     ##  ##     ##  ##    ## ##   ##  ##     ##        ##
//  ####   #####  ##   ##    ###    ##   ####  #####  ####
//
//= ============================================================

import { boot } from 'quasar/wrappers'
import * as Services from '../services'

const activeControllers = new Map()

const createServiceWithAbort = (service) => {
  return new Proxy(service, {
    get(target, propKey) {
      return (...args) => {
        const controller = new AbortController()
        const signal = controller.signal

        // Store the controller in the activeControllers map
        activeControllers.set(controller, true)

        // Call the actual service method with the signal
        const promise = target[propKey](...args, signal)

        // Cleanup controller when promise resolves or rejects
        promise.finally(() => {
          activeControllers.delete(controller)
        })

        return promise
      }
    },
  })
}

// Wrap each service with the abort functionality
/** @type {Services} */
const service = Object.keys(Services).reduce((acc, key) => {
  acc[key] = createServiceWithAbort(Services[key])
  return acc
}, {})

export default boot(({ app, router }) => {
  app.config.globalProperties.$service = service

  router.beforeEach((to, from, next) => {
    // Cancel all active requests on route change
    if (to.name !== from.name) {
      activeControllers.forEach((_, controller) => {
        controller.abort()
      })
      activeControllers.clear()
    }
    next()
  })
})

export { service }
